var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.216 13.529L8.882 1.654a1 1 0 00-1.765 0L.784 13.529A1 1 0 001.667 15h12.667a1 1 0 00.882-1.471zM8 13a1 1 0 110-2 1 1 0 010 2zm1-3H7V6h2v4z",
    fill: "#911444"
  })));
}

export default SvgWarning;